import http from '../../../../libs/http'
import config from '../../../../config/shops'

export default (queryParams = {}) => http.getUri({
  url: `${config.api}/inventory/download`,
  method: 'get',
  params: { ...queryParams }
})
